import OrderDTO from "@/dto/order/OrderDTO";
import { CompanySetting, getBuyerBlacklistSetting } from "@/services/api/setting/blacklist";
import to from "@/utils/to";
import { observable, when, makeObservable, actionBound } from "mobx";
import GlobalStore from "@/store";
import AppVersion from "@/enum/AppVersion";
import { isBlacklistOrder } from "@/utils/OrderUtils";

class CompanySettingStore {
    loading = false;

    companySetting: CompanySetting;

    constructor(public globalStore: typeof GlobalStore) {
        makeObservable(this, {
            loading: observable,
            companySetting: observable,
            ensureCompanySetting: actionBound,
            ensureLockBlacklistOrder: actionBound,
            ensureHintBlacklistDetail: actionBound,
        });
    }

    async ensureCompanySetting(cache = false) {
        if (cache && this.companySetting) return;

        if (this.loading) {
            await when(() => !this.loading);

            if (this.companySetting) return;
        }

        this.loading = true;

        const [_, setting] = await to(getBuyerBlacklistSetting());

        if (setting) {
            this.companySetting = setting;
        }

        this.loading = false;
    }

    /**
     * 是否锁黑名单订单需要满足下面条件
     * 1.黑名单设置中开启锁单
     * 2.订单中含有黑名单标签
     * 3.店铺需要为高级版
     */

    async ensureLockBlacklistOrder(order: OrderDTO) {
        if (!isBlacklistOrder(order)) return false;

        await this.ensureCompanySetting(true);

        if (!this.companySetting?.buyerBlacklistOrderLockEnabled) return false;

        await this.globalStore.ensureShopSetting([order.shopId]);

        if (this.globalStore.shopSettingMapping.get(order.shopId)?.appVersion !== AppVersion.PREMIUM) return false;

        return true;
    }

    /**
     * 是否显示黑名单细节需要满足下面条件
     * 1.订单中含有黑名单标签
     * 2.店铺需要为高级版
     */
    async ensureHintBlacklistDetail(order: OrderDTO) {
        if (!isBlacklistOrder(order)) return false;

        await this.ensureCompanySetting(true);
        await this.globalStore.ensureShopSetting([order.shopId]);

        if (this.globalStore.shopSettingMapping.get(order.shopId)?.appVersion !== AppVersion.PREMIUM) return false;

        return true;
    }
}

export default CompanySettingStore;
